import LAmap from './src/main'

/* istanbul ignore next */
LAmap.install = function(Vue) {
  Vue.component(LAmap.name, LAmap)
}

export default LAmap
